import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { convertiDataHM, monFetch } from "../inc/inc";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from "js-cookie";

import Popup from "../elementi/Popup";

const Comp = (props) => {
  const [versione, setVersione] = useState(null);
  const [versioniOld, setVersioniOld] = useState([]);
  const [cntQuestionari, setCntQuestionari] = useState(null);
  const [loading, setLoading] = useState(false);

  const [popupConferma, setPopupConferma] = useState(false);

  async function query() {
    const res = await monFetch("/surveyVersionDetail", {});
    setVersione(res.version);
    setCntQuestionari(res.cnt);
    setVersioniOld(res.versionsOld);
  }

  async function nuovaVersione() {
    setLoading(true);
    const res = await monFetch("/surveyVersionUpdate", {});
    if (res.success) {
      setVersione(res.version);
      setCntQuestionari(res.cnt);
      setLoading(false);
    }
  }

  async function exportExcel() {
    const res = await monFetch("/surveyExport", {});
    if (res.success) {
      let a = document.createElement("a");

      a.href =
        process.env.REACT_APP_BACKEND +
        "/surveyExportDownload/" +
        Cookies.get("token") +
        "/export-pss.xlsx";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
    }
  }

  useEffect(() => {
    props.setTestoTitolo(<>Gestione versioni questionario</>);
    query();
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Versione Attuale</TableCell>
            <TableCell>Codice versione</TableCell>
            <TableCell>Questionari somministrati</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{convertiDataHM(versione * 1000)}</TableCell>
            <TableCell>{versione}</TableCell>
            <TableCell>{cntQuestionari}</TableCell>
            <TableCell style={{ width: 300 }}>
              {loading ? (
                <CircularProgress />
              ) : (
                <div style={{ display: "flex", gap: 15 }}>
                  <Button
                    variant="contained"
                    className="buttonSalva"
                    onClick={() => setPopupConferma(true)}
                    style={{ minWidth: "auto" }}
                  >
                    Nuova&nbsp;versione
                  </Button>
                  <Button
                    variant="contained"
                    className="buttonSalva"
                    onClick={() => exportExcel()}
                  >
                    Esporta
                  </Button>
                </div>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Versioni precedenti</TableCell>
            <TableCell>Codice versione</TableCell>
            <TableCell>Questionari somministrati</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {versioniOld.map((ver) => {
            console.log(ver)
            return (
              <TableRow key={ver.version}>
                <TableCell>{convertiDataHM(ver.version * 1000)}</TableCell>
                <TableCell>{ver.version}</TableCell>
                <TableCell>{ver.cnt}</TableCell>
                <TableCell style={{ width: 300 }}></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <Popup
        open={popupConferma}
        titolo={"Conferma la creazione di una nuova versione"}
        testo={"Potrebbe volerci qualche minuto."}
        fnAnnulla={(e) => setPopupConferma(false)}
        fnSuccess={(e) => {
          nuovaVersione();
          setPopupConferma(false);
        }}
      />
    </>
  );
};

export default Comp;
